module.exports = __webpack_public_path__ + "static/media/trident.ce1d97ad.svg";